<template>
	<div class="ai_container">
		<Header :title="'결제하기'" :onClose="handleClose" />
		<div class="ai_wrapper_no_padding" style="paddingBottom: 90px">
			<PaymentSectionCard :title="'주문정보'">
				<div class="order_info_wrapper">
					<div class="image_wrapper">
						<img src="/static/images/ai/estimate.png" />
					</div>
					<div class="content_wrapper">
						<p class="body_8_M">{{ order_info.good_name }}</p>
						<b class="heading_8">{{ order_info.good_mny.toLocaleString() }}원</b>
					</div>
				</div>
			</PaymentSectionCard>
			<PaymentSectionCard :title="'차량정보'">
				<div class="car_info_wrapper">
					<ul>
						<li>
							<p class="body_8 f_gray_4">차량번호</p>
							<b class="body_8">{{ carNo }}</b>
						</li>
						<li>
							<p class="body_8 f_gray_4">브랜드</p>
							<b class="body_8">{{ brandName }}</b>
						</li>
						<li>
							<p class="body_8 f_gray_4">차종</p>
							<b class="body_8">{{ vehicleTypeName }}
								<!-- <span class="body_10 f_gray_4">520i M Sport Package A/T</span> -->
							</b>
						</li>
					</ul>
					<div class="caution_wrapper">
						<p class="heading_11">유의사항</p>
						<p class="body_11">
							견적 요청한 차량번호가 맞는지 한 번 더 확인해주세요.
						</p>
					</div>
				</div>
			</PaymentSectionCard>
			<PaymentSectionCard :title="'주문자정보'">
				<div class="customer_info_wrapper">
					<LabelInput :label="'이름'" :placeholder="'이름 입력'" :value="order_info.buyr_name"
						:onChange="handleNameChange" />
					<LabelInput :label="'연락처'" :placeholder="'연락처 입력'" :value="phone" :onChange="handlePhoneChange" />
					<LabelInput :label="'요청사항'" :placeholder="'견적 상담 시 참고사항 기재'" :value="memo" maxlength="50"
						:onChange="handleMemoChange" />
				</div>
			</PaymentSectionCard>
			<PaymentSectionCard :title="'결제수단'" v-if="finallyCharge > 0">
				<ul class="payment_method_list">
					<li :class="`${paymentMethod === option.value ? 'selected' : ''}`" v-for="option in paymentOptions"
						:key="option.name" @click="() => handlePaymentMethodChange(option.value)">
						<div class="payment_method_label">
							<img v-if="!!option.imageUrl"
								:src="`${option.imageUrl}${paymentMethod === option.value ? '' : '_gray'}.svg`"
								:alt="option.value" width="52px" />
							<p :class="`body_7_M ${paymentMethod === option.value ? '' : 'f_gray_4'}`">{{ option.name }}
							</p>
						</div>
						<div v-if="option.benefit" class="body_11 benefit">혜택</div>
					</li>
				</ul>
				<!-- <button class="card_benefit_button button_4 f_gray_4" @click="toggleBenefitModal">
			카드할인 및 무이자 혜택
			<img src="/static/icons/arrow/arrow_small_bold_right.svg"/>
		  </button> -->
			</PaymentSectionCard>
			<PaymentSectionCard :title="'결제정보'">
				<div class="payment_info_wrapper">
					<ul>
						<li>
							<p class="body_8">총 주문금액</p>
							<b class="heading_9">{{ baseCharge.toLocaleString() }}원</b>
						</li>
						<li v-if="applyType != '' && promoCharge !=0">
							<p class="body_8">프로모션 할인</p>
							<strong class="body_8_M f_red_1">{{ setPromo() }}</strong>
						</li>
					</ul>
					<div>
						<b class="heading_8">최종 결제 금액</b>
						<b class="heading_8">{{ finallyCharge.toLocaleString() }}원</b>
					</div>
				</div>
			</PaymentSectionCard>
			<!-- <PaymentTermList :onClickTermModalOpen="handleTermModalOpen" /> -->
		</div>
		<BottomFloatButton :label="`${finallyCharge.toLocaleString()}원 결제하기`" :disabled="!paymentMethod"
			:onClick="doPayment" :isFull="false" />
		<Modal
			v-if="!!termItem"
			:isVisible="!!termItem"
			:title="termItem.title"
			:onClose="handleTermModalClose"
			:hasPadding="true"
			:content="termItem.content"
			>
		</Modal>
		<Alert :isVisible="isAlert.isOpenAlert" :title="isAlert.title" :primaryText="'뒤로가기'"
			:onClickPrimary="handleAlertClose" />
		<Alert :isVisible="isRefreshAlert.isOpenAlert" :title="`결제할 금액이 변경되어 재조회 됩니다.`" :primaryText="'확인'"
			:onClickPrimary="handleRefreshAlertClose" />
		<form :action="formActionUrl" method="post" ref="form" accept-charset="euc-kr">
			<input id="pay_method" name="pay_method" type="hidden" v-model="order_info.pay_method" />
			<input id="site_cd" name="site_cd" type="hidden" v-model="order_info.site_cd" />
			<input id="currency" name="currency" type="hidden" v-model="order_info.currency" />
			<input id="shop_name" name="shop_name" type="hidden" v-model="order_info.shop_name" />
			<input id="Ret_URL" name="Ret_URL" type="hidden" v-model="order_info.Ret_URL" />
			<input id="approval_key" name="approval_key" type="hidden" v-model="order_info.approval_key" />
			<input id="PayUrl" name="PayUrl" type="hidden" v-model="order_info.PayUrl" />
			<input id="ordr_idxx" name="ordr_idxx" type="hidden" v-model="order_info.ordr_idxx" />
			<input id="good_name" name="good_name" type="hidden" v-model="order_info.good_name" />
			<input id="good_mny" name="good_mny" type="hidden" v-model="order_info.good_mny" />
			<input id="shop_user_id" name="shop_user_id" type="hidden" v-model="order_info.shop_user_id" />
			<input id="buyr_name" name="buyr_name" type="hidden" v-model="order_info.buyr_name" />
			<input id="traceNo" name="traceNo" type="hidden" v-model="order_info.traceNo" />
			<input id="payco_direct" name="payco_direct" type="hidden" value="Y" v-if="payco_direct" />
			<input id="kakaopay_direct" name="kakaopay_direct" type="hidden" value="Y" v-if="kakaopay_direct" />
			<input id="naverpay_direct" name="naverpay_direct" type="hidden" value="Y" v-if="naverpay_direct" />
		</form>
	</div>
</template>

<script>
import Vue from 'vue'
import Header from '@/components/ai/AiHeader.vue'
import Modal from '@/components/ai/AiModal.vue'
import BottomFloatButton from '@/components/ai/AiBottomFloatButton.vue'
import LabelInput from '@/components/ai/AiLabelInput.vue'
import SelectBox from '@/components/ai/AiSelectBox.vue'
import PaymentSectionCard from '@/components/ai/card/PaymentSectionCard.vue'
import CheckBox from '@/components/ai/AiCheckBox.vue'
import PaymentTermList from '@/components/ai/PaymentTermList.vue'
import Alert from '@/components/ai/AiAlert.vue'
import Utils from '@/modules/utils'
import AppConfig from '@/config'

export default {
	name: 'AiPayment',
	components: {
		Header,
		BottomFloatButton,
		LabelInput,
		PaymentSectionCard,
		SelectBox,
		CheckBox,
		PaymentTermList,
		Modal,
		Alert,
		Utils,
		AppConfig
	},
	computed: {
		estimateSeq() {
			return Vue.$sessionStorage.get('redirectseq');
		},
		channel(){
			return Vue.$sessionStorage.get('aiChannel')
		}
	},

	data() {
		return {
			isDisabled: true,
			name: '',
			phone: '',
			memo: '',
			paymentMethod: '',
			card: '',
			termItem: undefined,
			baseCharge: 0,
			promoCharge: 0,
			finallyCharge: 0,
			applyType: "",
			payco_direct: false,
			kakaopay_direct: false,
			naverpay_direct: false,
			isAlert: {
				isOpenAlert: false,
				title: ''
			},
			isRefreshAlert:{
				isOpenAlert: false
			},
			brandName: '',
			vehicleTypeName: '',
			carNo: '',
			paymentOptions: [
				{
					value: 'card',
					name: '카드결제',
					benefit: false
				},
				{
					imageUrl: '/static/icons/logo_kakaopay',
					value: 'kakaopay'
				},
				{
					imageUrl: '/static/icons/logo_payco',
					value: 'payco'
				},
				{
					imageUrl: '/static/icons/logo_navergr_small',
					value: 'naverpay'
				}
			],
			formActionUrl:'',
			order_info: {
				good_name: 'AI 수리견적 서비스',
				good_mny: '',
				buyr_name: '',
				pay_method: 'CARD',
				site_cd: '',
				currency: '410',
				shop_name: 'SpeedMate',
				Ret_URL: '',
				approval_key: '',
				PayUrl: '',
				ordr_idxx: '',
				shop_user_id: "SpeedMate",
				traceNo: ''
			}
		}
	},

	mounted() {
		if (Utils.isEmpty(this.estimateSeq)) {
			this.isAlert.isOpenAlert = true;
			this.isAlert.title = `비정상적인 접근입니다.`
		} else {
			let params={
				estimateSeq:this.estimateSeq,
				channel:this.channel
			}
			Vue.httpClient
			.post('/m/ai/dat/estimate/payCheck', params)
			.then(response => {
				if (response) {
					let result = response.data.result
					const estiCode = result.estimateStatusCode
					if(estiCode === '30' || estiCode === '40'){
						this.$router.push({name:'AiEstimate'});
					} else {
						this.vehicleTypeName = result.vehicleTypeName
						this.carNo = result.carNo
						this.brandName = result.brandName

						this.order_info.good_mny = result.finallyCharge
						this.order_info.buyr_name = result.aiUserName
						this.phone = result.aiMobileNumber

						this.baseCharge = result.baseCharge
						this.promoCharge = result.promoCharge
						this.finallyCharge = result.finallyCharge
						this.applyType = result.applyType

						if(this.finallyCharge === 0){
							this.paymentMethod = 'card'
						}
					}
				}
			})
			.catch((e) => {
				var msg = ''
				if (!Utils.isEmpty(e.data.result.message)) {
					msg = e.data.result.message
				} else {
					msg = '오류가 발생하였습니다\n뒤로 돌아갑니다.'
				}
				this.isAlert.isOpenAlert = true;
				this.isAlert.title = `${msg}`
			})
		}
	},

	methods: {
		setPromo() {
			var methodType = ''
			if (this.applyType === '10' || this.applyType === '30') {
				methodType = '원'
			} else if (this.applyType === '20') {
				methodType = '%'
			}

			return '- ' + this.promoCharge.toLocaleString() + methodType
		},
		doPayment() {
			// card일 경우 KCP_NORMAL site_cd
			// payco,kakaopay,naverpay일 경우 KCP_SIMPLE site_cd
			var $this = this;
			if ($this.paymentMethod == 'payco') {
				// payco
				$this.payco_direct = true
				$this.order_info.site_cd = AppConfig.KCP_SIMPLE
			} else if ($this.paymentMethod == 'kakaopay') {
				// kakaopay
				$this.kakaopay_direct = true
				$this.order_info.site_cd = AppConfig.KCP_SIMPLE
			} else if ($this.paymentMethod == 'naverpay') {
				// naverpay
				$this.naverpay_direct = true
				$this.order_info.site_cd = AppConfig.KCP_SIMPLE
			} else if ($this.paymentMethod == 'card') {
				// card
				$this.order_info.site_cd = AppConfig.KCP_NORMAL
			} else {
				return;
			}
			$this.order_info.Ret_URL = AppConfig.KCP_RET_URL

			const order_info = $this.order_info
			var params = {
				good_mny: order_info.good_mny,
				good_name: order_info.good_name,
				pay_method: order_info.pay_method,
				ret_URL: order_info.Ret_URL,
				estimateSeq: this.estimateSeq,
				channel: this.channel,
				paymentMethod: $this.paymentMethod,	//card - 일반결제, kakaopay, payco, naverpay - 간편결제
				userName:order_info.buyr_name,
				mobileNumber:this.phone,
				memo:this.memo
			}

			Vue.httpClient
			.post('/m/ai/interface/sendKcpReg', params)
			.then((response) => {
				if (response.data.status == 200) {
					if (response.data.result.Code === "0000") {
						$this.order_info.PayUrl = response.data.result.PayUrl
						$this.order_info.approval_key = response.data.result.approvalKey
						$this.order_info.traceNo = response.data.result.traceNo
						$this.order_info.ordr_idxx = response.data.result.ordr_idxx
						$this.formActionUrl = AppConfig.KCP_FORM_URL
						setTimeout(() => {
							$this.$refs.form.submit()
						}, 100);
					}else if(response.data.result.Code === "PASS"){
						this.$router.push({ name: 'AiEstimate' })
					} else if(response.data.result.Code === "REFRESH"){
						this.isRefreshAlert.isOpenAlert = true;
					}
				} else {
					throw new Error(response)
				}
			}).catch((e) => {
				console.log(e)
			})
		},
		handleDisabled() {
			var name = this.name
			var phone = this.phone
			var paymentMethod = this.paymentMethod

			this.isDisabled = true;

			if (name && phone && paymentMethod) {
				this.isDisabled = false;
			}
		},

		handleClose() {
			this.$router.go(-1)
		},
		handleNameChange(e) {
			this.order_info.buyr_name = e.target.value
			// this.handleDisabled();
		},
		handlePhoneChange(e) {
			this.phone = e.target.value
			// this.handleDisabled();
		},
		handleMemoChange(e) {
			this.memo = e.target.value
		},
		handlePaymentMethodChange(value) {
			this.paymentMethod = this.paymentMethod === value ? '' : value
			// this.handleDisabled();
		},
		handleAlertClose() {
			this.isAlert.isOpenAlert = false;
			this.$router.push({name:'AiMain'})
		},

		handleRefreshAlertClose() {
			this.isAlert.isRefreshAlert = false;
			this.$router.go(0);
		},

		handleTermModalOpen(index) {
			this.termItem = index
		},

		handleTermModalClose() {
			this.termItem = undefined
		}

	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiPayment.vue